var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5625 4.0625C3.5625 2.71631 4.65381 1.625 6 1.625C7.34619 1.625 8.4375 2.71631 8.4375 4.0625V5H3.5625V4.0625ZM2.4375 5.05265V4.0625C2.4375 2.09499 4.03249 0.5 6 0.5C7.96751 0.5 9.5625 2.09499 9.5625 4.0625V5.05265C10.9505 5.31594 12 6.53541 12 8V12.5C12 14.1569 10.6569 15.5 9 15.5H3C1.34315 15.5 0 14.1569 0 12.5V8C0 6.53541 1.04952 5.31594 2.4375 5.05265ZM7.5 10.25C7.5 11.0784 6.82843 11.75 6 11.75C5.17157 11.75 4.5 11.0784 4.5 10.25C4.5 9.42157 5.17157 8.75 6 8.75C6.82843 8.75 7.5 9.42157 7.5 10.25Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.001cae91cf51f117b7a41e117bdf4634.svg";
export { ForwardRef as ReactComponent };